import React from 'react';
import PropTypes from 'prop-types';
import SVGFactory from '../../../factories/svg';
import ReactTooltip from 'react-tooltip';

const propTypes = {
  refresh: PropTypes.func.isRequired,
};

const RefreshButton = (props) => {
  const { refresh, place } = props;
  return (
    <span onClick={refresh} className="refresh" data-tip data-for="refresh">
      Refresh feed
      <ReactTooltip
        id="refresh"
        type="light"
        effect="solid"
        place={place ? place : 'left'}
      >
        Refresh feed
      </ReactTooltip>
    </span>
  )
}

export default RefreshButton;
